module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"","copy":{"one":"","two":"","three":"","four":""}},"es-MX":{"title":"Instrucciones","copy":{"one":"Riguroso formal","two":"Riguroso formal","three":"Invitación personal","four":"Sólo adultos"}}}')
  delete Component.options._Ctor
}
